import { render } from "./HubsJoin.vue?vue&type=template&id=7382435d"
import script from "./HubsJoin.vue?vue&type=script&lang=js"
export * from "./HubsJoin.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__